import Button from "../ui/Button";
import ModalFormWrapper from "../shared/ModalFormWrapper";

const PortalAvinodeCtaModal = ({ closeModal, url }) => {
    //const authCtx = useContext(authContext)

    const openAvinodeHandler = () => {
        window.open(url, "_blank", "noreferrer");
        closeModal();
    };

    // Use effect
    // useEffect(() => {
    //         closeModal()

    // }, [closeModal, reason, navigate])

    return (
        <ModalFormWrapper title="AVINODE MARKETPLACE">
            {
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__body__title">Trip now created in Avinode</div>
                        <div className="login-form__body__intro">
                            You can select aircraft for this trip by clicking the marketplace link below
                        </div>

                        <div className="login-form__body__submit-container">
                            <Button onClick={openAvinodeHandler} classNames={["button--full"]}>
                                MARKETPLACE
                            </Button>
                        </div>
                    </div>
                </div>
            }
        </ModalFormWrapper>
    );
};

export default PortalAvinodeCtaModal;
